angular.module('wbDirectives').directive 'wbFocusOn', ->
  link: ($scope, $el, $attrs) ->
    $scope.$watch $attrs.wbFocusOn, (value) ->
      return unless value
      # Use a timeout here because of DOM timing issues
      setTimeout ->
        $el.focus()
      , 20

